export enum EntityNoteType {
  Basic = 0,
  AgentNote = 1,
  CodeRed = 2,
  Issue = 3,
  Hotel = 4,
  Client = 5,
  Frontier = 6,
  OBTNote = 7
}
